import React from 'react'
import { Paper, makeStyles, Typography, Breadcrumbs, Link } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  footer: {
    padding: '20px',
    borderTop: '1px solid lightgrey',
    marginTop: '40px',
    alignItems: 'center',
  },
  breadcrumbs: {
    marginBottom: '20px'
  }
}))

const Footer = () => {
    const classes = useStyles();

    return (
      <Paper elevation={0} square className={classes.footer}>
        <Breadcrumbs className={classes.breadcrumbs}>
          <Link href="https://www.comon.ru/strategies/" color="textPrimary" target="_blank">
            Стратегии
          </Link>
          <Link href="https://www.comon.ru/info/news/" color="textPrimary" target="_blank">
            Новости
          </Link>
          <Link href="https://www.comon.ru/?chat-widget-open=true" color="textPrimary" target="_blank">
            Поддержка
          </Link>
          <Link href="https://zaoik.finam.ru/" color="textPrimary" target="_blank">
            Раскрытие информации
          </Link>
        </Breadcrumbs>
        <Typography variant="body2" color="textSecondary">
          Информация, публикуемая пользователями на сайте (в блогах, комментариях, чате, сообществах
          и т.д.) является личным (субъективным) мнением, суждением или выражением конкретного
          пользователя и не может являться основополагающей для принятия инвестиционных решений
          (покупки и/или продажи ценных бумаг) или побуждающей совершить какие-либо юридические или
          фактические действия. Администрация сайта не несёт ответственности за принятые решения,
          основанные на такой информации, а также в случае если такая информация направлена на
          возбуждение ненависти и/или вражды по отношению к каким-либо группам лиц, народам
          каких-либо национальностей, расам и каким-либо другим социальным группам и категориям лиц.
        </Typography>
        <br/>
        <Typography variant="body2" color="textSecondary">
          На сайте осуществляется обработка пользовательских данных с использованием Cookie в соответствии с{' '}
          <Link href="/general-information/user-data-processing/" color="secondary">
            Правилами обработки пользовательских данных
          </Link>
          .
        </Typography>
      </Paper>
    );
}

export default Footer;
